<template>
  <div>
    <v-card :disabled="isProcessing" :loading="isProcessing">
      <template v-slot:progress>
        <v-progress-linear
          absolute
          color="success"
          height="4"
          indeterminate
        ></v-progress-linear>
      </template>
      <v-tabs v-model="tab" class="crm-color" left dark icons-and-text>
        <v-tabs-slider></v-tabs-slider>
        <v-tab href="#tab-1">
          <v-toolbar-title>{{ title }}</v-toolbar-title>
        </v-tab>
        <v-spacer></v-spacer>
        <div class="buttons-tab"></div>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item value="tab-1">
          <v-card flat>
            <v-card-text>
              <v-form ref="unitConversionForm" v-model="validForm" @submit.prevent>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="requestData.unit"
                      :label="`${$t('UNIT_CONVERSIONS.UNIT')} *`"
                      :rules="[validations.required()]"
                      :error-messages="validationErrors.unit || []"
                      @change="clearValidationError('unit')"
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="requestData.to_kg"
                      type="number"
                      step="any"
                      :label="`${$t('UNIT_CONVERSIONS.TO_KG')} *`"
                      :rules="[validations.required()]"
                      :error-messages="validationErrors.to_kg || []"
                      @change="clearValidationError('to_kg')"
                    />
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="warning" @click="back">
                {{ $t("GENERAL.LABELS.BACK_BUTTON") }}
              </v-btn>
              <v-btn color="success" @click="store">
                {{ actionText }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import validations from "@/views/partials/form/Validations.vue";
import { SHOW_SNACK } from "@/store/snack.module";
import userStateService from "@/common/userState.service.js";
import {
  GET_UNIT_CONVERSION,
  STORE_UNIT_CONVERSION,
  UPDATE_UNIT_CONVERSION,
} from "@/store/unit_conversions.module";

export default {
  name: "EditUnitConversion",
  data() {
    return {
      validations,
      tab: "tab-1",
      isProcessing: false,
      validForm: false,
      validationErrors: {},
      title: "",
      actionText: this.$t("GENERAL.LABELS.CREATE_BUTTON"),
      requestData: {
        unit: "",
        to_kg: 1,
      },
    };
  },
  computed: {
    isEditMode() {
      return Boolean(this.$route.params.id);
    },
  },
  mounted() {
    this.title = this.$t("UNIT_CONVERSIONS.CREATE");
    this.loadUnitConversion();
  },
  methods: {
    getErrorMessage(error) {
      if (error && error.errors && typeof error.errors === "object") {
        const firstErrorField = Object.keys(error.errors)[0];
        const firstErrorList = error.errors[firstErrorField];

        if (Array.isArray(firstErrorList) && firstErrorList.length) {
          return firstErrorList[0];
        }
      }

      if (error && error.message) {
        return error.message;
      }

      return this.$t("GENERAL.UNEXPECTED_ERROR");
    },
    setValidationErrors(error) {
      this.validationErrors = (error && error.errors) || {};
    },
    clearValidationError(field) {
      if (!this.validationErrors[field]) {
        return;
      }

      this.$delete(this.validationErrors, field);
    },
    loadUnitConversion() {
      if (!this.$route.params.id) {
        return;
      }

      this.title = this.$t("UNIT_CONVERSIONS.EDIT");
      this.actionText = this.$t("GENERAL.LABELS.EDIT_BUTTON");
      this.isProcessing = true;

      this.$store
        .dispatch(GET_UNIT_CONVERSION, this.$route.params.id)
        .then((response) => {
          this.requestData = {
            unit: response.unit || "",
            to_kg: response.to_kg ?? 1,
          };
        })
        .catch((error) => {
          this.$store.dispatch(SHOW_SNACK, {
            message: this.getErrorMessage(error),
            type: "error",
          });
          this.back();
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
    back() {
      this.$router.push({ name: "unit-conversions" });
    },
    store() {
      this.$refs.unitConversionForm.validate();

      if (!this.validForm) {
        return;
      }

      this.validationErrors = {};

      const action = this.isEditMode ? UPDATE_UNIT_CONVERSION : STORE_UNIT_CONVERSION;
      const payload = {
        unit: this.requestData.unit,
        to_kg: this.requestData.to_kg,
      };

      if (this.isEditMode) {
        payload.id = this.$route.params.id;
      }

      this.isProcessing = true;

      this.$store
        .dispatch(action, payload)
        .then((response) => {
          const blinkId = response?.id || this.$route.params.id;

          if (blinkId) {
            userStateService.setState(
              "table-state.unit-conversions-table.blinkRowItemKey",
              blinkId
            );
          }

          this.$store.dispatch(SHOW_SNACK, {
            message: this.$t("GENERAL.SUCCESS_MESSAGE"),
          });
          this.$router.push({ name: "unit-conversions" });
        })
        .catch((error) => {
          this.setValidationErrors(error);
          this.$store.dispatch(SHOW_SNACK, {
            message: this.getErrorMessage(error),
            type: "error",
          });
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
  },
};
</script>
